/* Stanbarry Personalisierungsfelder (personalized-inputs.liquid):
   Pflichtfelder vor dem Theme-Handler prüfen (Fehler am Feld, kein alert), Rückseiten-Upsell ein-/ausschalten,
   Zeichenzähler, Menge des Upsells = Menge des Hauptprodukts, leere optionale Felder nicht übergeben,
   Eingaben über einen Variantenwechsel (Section-Rerender) hinweg behalten. Kein Eingriff in product-form.js. */
(function () {
  'use strict';
  var memory = {};              // Property-Name -> zuletzt getippter Wert (überlebt ein Rerender der Section)
  var addonMemory = {};         // Root-ID -> Haken gesetzt?

  function formOf(root) {
    var f = document.getElementById(root.getAttribute('data-form'));
    if (f) return f;
    var sec = root.closest('.shopify-section') || document;
    f = sec.querySelector('form[action*="/cart/add"]');
    if (f && f.getAttribute('id')) {
      // Theme nutzt eine andere Formular-ID: Zuordnung der Felder nachziehen
      root.querySelectorAll('[form]').forEach(function (el) { el.setAttribute('form', f.getAttribute('id')); });
    }
    return f;
  }

  function init(root) {
    if (root.__pi) return;
    var form = formOf(root);
    if (!form) return;
    root.__pi = true;
    var rootId = root.getAttribute('data-form');
    var inputs = function () { return Array.prototype.slice.call(root.querySelectorAll('[data-pi-input]')); };
    var addon = root.querySelector('[data-pi-addon]');
    var body = root.querySelector('.sb-addon-body');

    function propName(input) { var m = /^properties\[(.*)\]$/.exec(input.name); return m ? m[1] : input.name; }
    function updateCount(input) {
      var em = input.closest('.sb-field').querySelector('[data-pi-count]');
      if (em) em.textContent = input.value.length + '/' + input.getAttribute('maxlength');
    }
    function errorEl(input) {
      var box = input.closest('.sb-field');
      return box && box.nextElementSibling && box.nextElementSibling.hasAttribute('data-pi-error') ? box.nextElementSibling : null;
    }
    function clearError(input) {
      input.classList.remove('is-error');
      var e = errorEl(input);
      if (e) e.hidden = true;
    }
    function setAddon(on) {
      if (!addon) return;
      addon.checked = on;
      addon.setAttribute('aria-expanded', on ? 'true' : 'false');
      addon.closest('.sb-addon').classList.toggle('is-active', on);
      if (body) body.hidden = !on;
      root.querySelectorAll('[data-pi-back], [data-pi-addon-item]').forEach(function (el) { el.disabled = !on; });
      if (!on) {
        root.querySelectorAll('[data-pi-back]').forEach(clearError);
        var be = root.querySelector('[data-pi-back-error]');
        if (be) be.hidden = true;
      }
      addonMemory[rootId] = on;
    }

    // Eingaben aus dem Speicher zurückholen (nach Variantenwechsel)
    inputs().forEach(function (i) {
      var k = propName(i);
      if (memory[k] && !i.value) i.value = memory[k];
      updateCount(i);
    });
    if (addon) setAddon(!!addonMemory[rootId]);

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.hasAttribute('data-pi-input')) return;
      memory[propName(t)] = t.value;
      updateCount(t);
      if (t.value.trim()) {
        clearError(t);
        if (t.hasAttribute('data-pi-back')) {
          root.querySelectorAll('[data-pi-back]').forEach(clearError);
          var be = root.querySelector('[data-pi-back-error]');
          if (be) be.hidden = true;
        }
      }
    });
    if (addon) {
      addon.addEventListener('change', function () {
        setAddon(addon.checked);
        if (addon.checked) {
          var first = root.querySelector('[data-pi-back]');
          if (first) first.focus({ preventScroll: true });
        }
      });
    }

    function addonOn() { return !!(addon && addon.checked); }
    function check() {
      var missing = inputs().filter(function (i) {
        return !i.hasAttribute('data-pi-back') && i.getAttribute('data-pi-required') === '1' && !i.value.trim();
      });
      var backMissing = false;
      if (addonOn()) {
        var back = inputs().filter(function (i) { return i.hasAttribute('data-pi-back'); });
        var req = back.filter(function (i) { return i.getAttribute('data-pi-required') === '1'; });
        // Mit Pflicht-Haken: diese müssen gefüllt sein. Ohne: mindestens ein Rückseitentext (sonst zahlt der Kunde für nichts).
        backMissing = req.length ? req.some(function (i) { return !i.value.trim(); }) : (back.length > 0 && !back.some(function (i) { return i.value.trim(); }));
      }
      return { missing: missing, back: backMissing, ok: !missing.length && !backMissing };
    }
    function show(res) {
      inputs().forEach(function (i) { if (!i.hasAttribute('data-pi-back')) clearError(i); });
      res.missing.forEach(function (i) {
        i.classList.add('is-error');
        var e = errorEl(i);
        if (e) e.hidden = false;
      });
      var be = root.querySelector('[data-pi-back-error]');
      if (be) be.hidden = !res.back;
      root.querySelectorAll('[data-pi-back]').forEach(function (i) { i.classList.toggle('is-error', res.back); });
      var first = res.missing[0] || (res.back ? root.querySelector('[data-pi-back]') : null);
      if (first) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        first.focus({ preventScroll: true });
      }
      root.classList.remove('is-shake');
      void root.offsetWidth;
      root.classList.add('is-shake');
    }
    function syncQty() {
      var q = form.querySelector('[name="quantity"]');
      var qi = root.querySelector('[data-pi-addon-qty]');
      if (q && qi) qi.value = String(Math.max(1, parseInt(q.value, 10) || 1));
    }
    // Leere optionale Felder kurz abschalten, damit sie nicht als leere Property mitgehen
    function hideEmpty() {
      var tmp = inputs().filter(function (i) { return !i.disabled && !i.value.trim(); });
      tmp.forEach(function (i) { i.disabled = true; });
      setTimeout(function () { tmp.forEach(function (i) { i.disabled = false; }); }, 0);
    }
    function guard(e) {
      syncQty();
      var res = check();
      if (!res.ok) {
        e.preventDefault();
        e.stopImmediatePropagation();
        show(res);
        return false;
      }
      hideEmpty();
      return true;
    }
    root.__piGuard = { form: form, guard: guard };
  }

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-sb-pi]')); }
  function guardFor(form) {
    var r = roots().filter(function (x) { return x.__piGuard && x.__piGuard.form === form; })[0];
    return r ? r.__piGuard.guard : null;
  }

  // Capture-Phase am Dokument: läuft vor dem Theme-Handler (product-form.js) auf demselben Formular
  document.addEventListener('submit', function (e) {
    var g = guardFor(e.target);
    if (g) g(e);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"], button[name="add"], .product-form__submit');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    var g = form && guardFor(form);
    if (g && !g(e)) return;
  }, true);

  function boot() { roots().forEach(init); }
  boot();
  // Theme rendert die Section beim Variantenwechsel neu → neu einhängen
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
